export const TOUR_DOMAINS = [
  'my.matterport.com',
  'remax.spacelab.zone',
  'giraffe360.com',
  'www.rundgang.at',
  'real3motion.com',
  '.vr-360-tour.com',
  'pics.picmyplace.eu',
  'panoview.3d-architektur-profi.de',
  'my.panoroom.at',
  '360.eostrixvision.com',
  'storage.net-fs.com',
  'enovaspace.at',
  'tour.ogulo.com',
  'twinmotion.unrealengine.com',
  '360.remax.at',
];

export const DOWNLOADABLE_MEDIA_KEYS = ['doc', 'xls', 'avi', 'wmf', 'mov', 'wmv', 'pdf'];

export const FOOTER_TABS_MUNICIPALITIES_LABEL = 'Ähnliche Objekte in umliegenden Gemeinden';
export const FOOTER_TABS_DISTRICTS_LABEL = 'Ähnliche Objekte in umliegenden Bezirken';
